import React from 'react';
import { Button, Carousel, Container } from 'react-bootstrap';
import { BiLinkExternal } from 'react-icons/bi';
import Particle from '../../Particle';

import home from "../../../Images/Project/learnfast/learnHome.JPG";
import feature from "../../../Images/Project/learnfast/featureCourse.JPG";
import service from "../../../Images/Project/learnfast/allCourse.JPG";
import login from "../../../Images/Project/learnfast/learnSignup.JPG";

const LearnFast = () => {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    LearnFast <strong className="purple"> Website </strong>
                </h1>
                <div className='mt-5 mb-5'>
                    <div className='container '>
                        <div className='row '>
                            <div className='col-lg-6 col-sm-12'>
                                <Carousel fade>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={home}
                                            alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={feature}
                                            alt="Second slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={service}
                                            alt="Third slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={login}
                                            alt="fourth slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </div>
                            <div className='col-lg-6 col-sm-12'>
                                <p className='text-white'>Learnfast is a self learning platform that offers various digital courses. Our mission is to prepare the next generation suitable enough to face modern challenges. Here our courses are designed with the help of experts and being continuously updated so that no one lags behind knowledge.</p>

                                <p className='text-white'>
                                    <ul>
                                        <li>Live classes</li>
                                        <li>Timed tests</li>
                                        <li>Live feedback session</li>
                                        <li>Problem Discussion chat ro</li>
                                    </ul></p>
                                <p className='text-white'> Technology: React js, Bootstrap,React Router, Firebase Authentication</p>

                                <Button href='https://github.com/nhnajmul17/learn-fast-react-education' style={{ marginRight: '3px' }} className='btn btn-info '>  <BiLinkExternal /> &nbsp;Client Side</Button>


                                <Button href='https://learn-fast-01.web.app/' className='btn btn-info'>  <BiLinkExternal /> &nbsp;Live Site</Button>

                            </div>

                        </div>

                    </div>


                </div>


            </Container>
        </Container>
    );
};

export default LearnFast;